import { render } from "./rqzjHome.vue?vue&type=template&id=ec34ec50"
import script from "./rqzjHome.vue?vue&type=script&lang=js"
export * from "./rqzjHome.vue?vue&type=script&lang=js"

import "./rqzjHome.vue?vue&type=style&index=0&id=ec34ec50&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__